// Scoped strings: no changes to shared TinyMCE/image translations.
const en = {
  insert: 'Insert PDF',
  remove: 'Remove PDF',
  selectPdf: 'PDF to remove',
  removeHelp: 'This removes the PDF from this text only. The file stays in Files & Uploads and other content is unchanged. You can undo this action.',
  cancel: 'Cancel',
  uploadTab: 'Upload PDF',
  moreTabs: 'More',
  existingTab: 'Choose from Files & Uploads',
  existingHelp: 'Reuse a PDF from this course. No new copy will be uploaded.',
  loading: 'Loading course PDFs…',
  loadError: 'We could not load the course files. Try again.',
  search: 'Search PDF by name',
  noPdfs: 'There are no PDFs in this course yet. Use Upload PDF to add one.',
  noResults: 'No PDFs match this name.',
  selected: 'PDF selected from Files & Uploads',
  another: 'Choose another PDF',
  drop: 'Drag your PDF here',
  browse: 'or click to browse',
  help: 'Your PDF will be saved in this course’s Files & Uploads.',
  uploading: 'Uploading PDF…',
  ready: 'PDF uploaded successfully',
  title: 'Document title',
  titleHelp: 'A clear title helps learners using screen readers.',
  height: 'Height (pixels)',
  settings: 'Display settings',
  invalid: 'Select one PDF file.',
  empty: 'This file is empty. Select another PDF.',
  error: 'We could not upload the PDF. Try again.',
  retry: 'Try again',
  large: 'The PDF exceeds the course upload limit. Choose a smaller file.',
  duplicate: 'A file with this name already exists in Files & Uploads. Replacing it also updates content that uses that file.',
  replace: 'Replace existing file',
  choose: 'Choose another PDF',
  retained: 'Closing this window keeps the uploaded PDF in Files & Uploads.',
  invalidSettings: 'Enter a title and a height between 200 and 2000 pixels.',
};
const es = {
  insert: 'Insertar PDF',
  remove: 'Quitar PDF',
  selectPdf: 'PDF que quieres quitar',
  removeHelp: 'Se quitará el PDF solo de este Texto. El archivo seguirá en Files & Uploads y los demás contenidos no cambiarán. Puedes deshacer esta acción.',
  cancel: 'Cancelar',
  uploadTab: 'Subir PDF',
  moreTabs: 'Más',
  existingTab: 'Elegir de Files & Uploads',
  existingHelp: 'Reutiliza un PDF de este curso. No se subirá otra copia.',
  loading: 'Cargando los PDF del curso…',
  loadError: 'No pudimos cargar los archivos del curso. Intenta nuevamente.',
  search: 'Buscar PDF por nombre',
  noPdfs: 'Todavía no hay PDF en este curso. Usa Subir PDF para añadir uno.',
  noResults: 'No hay PDF que coincidan con ese nombre.',
  selected: 'PDF seleccionado de Files & Uploads',
  another: 'Elegir otro PDF',
  drop: 'Arrastra tu PDF aquí',
  browse: 'o haz clic para buscar',
  help: 'El PDF se guardará en Files & Uploads de este curso.',
  uploading: 'Subiendo PDF…',
  ready: 'PDF cargado correctamente',
  title: 'Título del documento',
  titleHelp: 'Un título claro ayuda a quienes utilizan lectores de pantalla.',
  height: 'Altura (píxeles)',
  settings: 'Opciones de visualización',
  invalid: 'Selecciona un solo archivo PDF.',
  empty: 'El archivo está vacío. Selecciona otro PDF.',
  error: 'No pudimos subir el PDF. Intenta nuevamente.',
  retry: 'Reintentar',
  large: 'El PDF supera el límite de subida del curso. Selecciona un archivo más pequeño.',
  duplicate: 'Ya existe un archivo con este nombre en Files & Uploads. Reemplazarlo también actualiza los contenidos que lo utilizan.',
  replace: 'Reemplazar archivo existente',
  choose: 'Elegir otro PDF',
  retained: 'Al cerrar esta ventana, el PDF cargado permanece en Files & Uploads.',
  invalidSettings: 'Escribe un título y una altura entre 200 y 2000 píxeles.',
};
export default (locale = '') => (locale.toLowerCase().startsWith('es') ? es : en);
